import { ServiceData } from '@/types';

import articles from './LOVE_ARTICLES_EE.json';
import audios from './LOVE_AUDIOS_EE.json';

export const LOVE_DATA_EE: ServiceData = {
  articles,
  audios,
};
